import { CONFIG } from './config';
import axios from "axios";
const baseURL = CONFIG.BASE_URL

export const getPacchetti = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/pacchetti");
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setPacchetto = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/pacchetti", data);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getSezioni = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    params: data
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/sezioni", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getNextSezione = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    params: data
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/nextSezione", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getSezione = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    params: data
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/sezione", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setSezione = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/sezione", data, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setBackToPratica = (id_pratica, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/backPratica", {id_pratica: id_pratica}, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setSezioneUpload = (file, data, token) => {
  const headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "multipart/form-data",
  };
  const bodyFormData = new FormData();
  bodyFormData.append("id_sezione", data.id_sezione);
  bodyFormData.append("id_pratica", data.id_pratica);
  bodyFormData.append("data", JSON.stringify(data.data));
  // bodyFormData.append("upload_documento", file[0]);

  file.map((f, index) => {
    bodyFormData.append("upload_documento_" + index, f);
  });

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios({
        method: "post",
        url: baseURL + "/sezione",
        data: bodyFormData,
        headers: headers,
      });
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getPratica = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/recupera", { params: data });
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getPraticaOtp = (data) => {
  let tokenOperatore = localStorage.getItem('tokenOperatore')
  
  return new Promise(async (resolve, reject) => {
    try {
      let response = null;
      if(tokenOperatore)
      {
        let config = {
          headers: {
            Authorization: "Bearer " + tokenOperatore,
          },
        };
        response = await axios.post(baseURL + "/recupera/otp", data, config);
      }
      else
      {
        response = await axios.post(baseURL + "/recupera/otp", data);
      }
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getPraticaVerifica = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/verifica", data);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getStatoPratica = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    params: data
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/stato", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getDocumenti = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    params: data
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/documenti", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const postDownloadDocumenti = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    responseType: 'blob'
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/documenti", data, config);
      resolve(response.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setStartFirma = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/startFirma", data, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setConfermaFirma = (data, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/confermaFirma", data, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};


export const getDinamico = (data, token, path) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    params: data
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + path, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const postDinamico = (data, token, path) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + path, data, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getTassi = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/tassi");
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getListaPratiche = () => {
  let tokenOperatore = localStorage.getItem('tokenOperatore')
  let config = {
    headers: {
      Authorization: "Bearer " + tokenOperatore,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/listaPratiche", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const recuperaPraticaOperatore = (data) => {
  let tokenOperatore = localStorage.getItem('tokenOperatore')
  let config = {
    headers: {
      Authorization: "Bearer " + tokenOperatore,
    },
  };
  
  return new Promise(async (resolve, reject) => {
    try {
      let response = await axios.post(baseURL + "/recuperaPratica", data, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const checkTokenOperatore = (token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/checkToken", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const getPacchettiOperatore = () => {
  let tokenOperatore = localStorage.getItem('tokenOperatore')
  let config = {
    headers: {
      Authorization: "Bearer " + tokenOperatore,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + "/pacchetti", config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const setPacchettoOperatore = (data) => {
  let tokenOperatore = localStorage.getItem('tokenOperatore')
  let config = {
    headers: {
      Authorization: "Bearer " + tokenOperatore,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(baseURL + "/pacchetti", data, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};

export const searchValue = (url, value, token) => {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(baseURL + url + '?value='+value, config);
      resolve(response.data.data);
    } catch (error) {
      reject(error.response &&
        error.response.data &&
        error.response.data.data
        ? error.response.data.data
        : error.response.data.message);
    }
  });
};